import { render, staticRenderFns } from "./formFinancialRatios.vue?vue&type=template&id=853ad73e&scoped=true"
import script from "./formFinancialRatios.vue?vue&type=script&lang=js"
export * from "./formFinancialRatios.vue?vue&type=script&lang=js"
import style0 from "./formFinancialRatios.vue?vue&type=style&index=0&id=853ad73e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "853ad73e",
  null
  
)

export default component.exports